import { ReactNode } from 'react';
import { ItemWithLabel } from '../../../components';
import Product from './Product';
import { SellableDto } from './sellable/Sellable';
import Sellables from './sellable/Sellables';

export default class Products extends Sellables<Product> {
  itemName = 'product';

  toOptions(
    emptyText: ReactNode = 'Not set',
    keepArchived = false,
  ): ItemWithLabel[] {
    const labels: ItemWithLabel[] = this.items
      .filter((product) => !product.archived || keepArchived)
      .map((product) => ({
        label: product.displayName,
        value: product.id,
      }));

    if (emptyText) {
      labels.unshift({ value: '', label: emptyText });
    }

    return labels;
  }

  getProductDisplayName(productId: string): string {
    if (!productId) {
      return '';
    }

    const product = this.items.find((item) => item.id === productId);
    return product?.displayName || `#${productId}`;
  }

  getProductSku(productId: string): string {
    if (!productId) {
      return '';
    }

    const product = this.items.find((item) => item.id === productId);
    return product?.sku || '';
  }

  protected unserialize(dto: SellableDto): Product {
    return new Product(dto);
  }
}
